import {defineMessages} from 'react-intl';

const messages = defineMessages({
    TITLE: {
        id: 'spareParts.managementGroup.title',
        defaultMessage: 'Management Group'
    },
    FORM_TITLE: {
        id: 'spareParts.managementGroup.form.subject',
        defaultMessage: 'Input file for Management Group change'
    },
    ATTACHMENT_FIELD: {
        id: 'spareParts.managementGroup.label.attachment',
        defaultMessage: 'Attachment'
    },
    TOTAL_PARTS_LABEL: {
        id: 'spareParts.managementGroup.label.totalParts',
        defaultMessage: 'Total parts to update'
    },
    LAST_BATCH_LABEL: {
        id: 'spareParts.managementGroup.label.lastBatch',
        defaultMessage: 'Last batch'
    },
    STATUS_LABEL: {
        id: 'spareParts.managementGroup.label.status',
        defaultMessage: 'Batch status'
    },
    UPDATED_TICKETS_LABEL: {
        id: 'spareParts.managementGroup.label.updatedTickets',
        defaultMessage: 'Updated tickets'
    },
    LOADED_PARTS_LABEL: {
        id: 'spareParts.managementGroup.label.loadedParts',
        defaultMessage: 'Loaded parts'
    },
});

export default messages;
